var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-grow-1 justify-end flex-wrap ml-2"},[_c('v-chip',{staticClass:"mr-2 my-1",attrs:{"outlined":"","small":"","color":_vm.borderColor,"text-color":"black"}},[_vm._v(" "+_vm._s(_vm.role)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }